/**
 * Служебная загрузка содержимого url-окна (плагин open-modal-url.js, 1 файл — 1 функция): GET по уже разрешённому
 * config.url с _t=Date.now(), чтобы браузер не отдавал устаревший контент из кеша. Ответ вставляется единственной
 * точкой window.openModalWindowSetContent — хуки onBefore/AfterContentInsert срабатывают вокруг вставки; при ошибке
 * или ответе не-HTML в .modal-body кладётся alert-danger. Крутилку-плейсхолдер до запроса ставит инициатор:
 * open-modal-url.js при открытии (show.bs.modal) и reload-content.js при повторной загрузке. Вызывается после
 * shown.bs.modal и из алиаса «reload-content»; аргумент element не используется — url уже разрешён в config.
 */

window.openModalWindowFunctions["load-content"] = function (element, config) {
    let bodyBox = config.modal.find(".modal-body");

    if (!config.url) {
        console.warn("[modal-url] Не указан URL содержимого окна: передайте config.url или добавьте data-url/href на элемент-триггер");
        return null;
    }

    // Окно могли закрыть во время запроса — в мёртвое окно контент и хуки не отправляем.
    let isAlive = function () {
        return config.modal.closest("body").length > 0;
    };

    let errorHtml = '<div class="alert alert-danger m-0">Не удалось загрузить содержимое</div>';

    let sep = config.url.indexOf("?") === -1 ? "?" : "&";
    jQuery.ajax({
        url: config.url + sep + "_t=" + Date.now(),
        type: "GET"
    }).done(function (html) {
        if (!isAlive()) return;

        if (typeof html !== "string") {
            console.warn("[modal-url] Ожидался HTML, получен: ", typeof html);
            bodyBox.html(errorHtml);
            return;
        }

        // Хуки вокруг вставки: onBeforeContentInsert успевает повесить делегирование до появления формы в DOM.
        window.openModalWindowSetContent(config, html);
    }).fail(function () {
        console.warn("[modal-url] Не удалось загрузить содержимое: " + config.url);
        if (!isAlive()) return;
        bodyBox.html(errorHtml);
    });
};
